module.exports = __webpack_public_path__ + "static/media/C003.d4fd1d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C003.jpg
// module id = 286
// module chunks = 0